import React from "react";
import Main from "../main";

export default function Particles() {
  return (
    <Main>
      <div>Polite Particles</div>
      <div>
        In Vietnamese, there are special particles for expressing politeness.
      </div>
      <div>
        <p>
          One of these particles <span className="font-bold"> ạ </span>
        </p>
      </div>
      <div>
        <p>
          The particle <span className="font-bold"> ạ </span> has no translation
        </p>
      </div>
      <div>
        It is used as a sign of respect when greeting, when asking, when
        answering questions.
      </div>
      <div>
        - <p className="font-bold">Cháu chào bác ạ.</p>
      </div>
    </Main>
  );
}
